export default {
    token: '',
    guestId: '', //嘉宾id
    userInfo: {}
};